import { ENV } from "../utils";

export class Area {
  baseApi = ENV.BASE_API;

  async getAreas(accessToken, active = true) {
    const url = `${this.baseApi}/areas?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createArea(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-area`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateArea(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-area/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteArea(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-area/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
